<template>
  <header>
    <div class="flex" v-if="!this.$props.isPastRun">
      <div class="flex" style="width:30%">
        <div class="description">
          <div class="name">
            {{ race.name }} with {{ trainer.firstName }} {{ trainer.lastName }}.
            <span v-if="isAutoPilotRace" class="autopilot-pill" v-tooltip="{content: autopilotTooltip, placement: 'bottom'}">AUTOPILOT</span>
            <button v-if="isAutoPilotRace" class="auto-start-button" @click="startAutoRun" v-tooltip="{content: 'You can use this button to start the auto run process manually', placement: 'bottom'}">START NOW</button>
          </div>
          <span> Start {{ time }} &nbsp; {{ date(race.date) }}</span>
          <span style="color: red" v-if="!raceStarted">To start  {{ minutesLeft }}&quot;{{ secondsLeft }}</span>
          <div class="steaming-url" v-if="channel">
            <span>Channel : </span> {{ channel }}
            <span class="rsvp_limit" v-if="race.rsvp_limit">RSVP Limit : </span> {{ race.rsvp_limit }}
          </div>
          <div class="steaming-url" v-else>
            <span>No Channel Found</span>
          </div>
          <div v-if="currentChannel" class="channelInfo">
            <div>{{ currentChannel.id }}</div>
            <div>{{ currentChannel.pwd }}</div>
            <div>{{ currentChannel.desc }}</div>
          </div>
        </div>
      </div>

      <div class="actions" v-if="Object.keys(race).length >= 0">
        <div id="app-buttons">
          <button class="btn  btn--primary notification-button" :disabled="isStartLive"
                  @click="openNotification(race.id)">Notification
          </button>
          <button id="Standby" :disabled="CurrentRaceStatus!=2" class="btn btn--primary" @click="standBy"
                  v-if="isQuestion">StandBy
          </button>
          <button id="Standby" :disabled="CurrentRaceStatus!=2" class="btn btn--primary"
                  @click="showQuestionModalNow(true)" v-if="!isQuestion">StandBy
          </button>
          <button id="live-button" class="btn btn--primary" @click="startLive" :disabled="CurrentRaceStatus!=3">Start
            Live
          </button>
          <button id="StartRun" class="btn btn--primary" @click="startRace" :disabled="CurrentRaceStatus!=4">Start Run
          </button>
          <button id="FinishRun" class="btn btn--primary" :disabled="CurrentRaceStatus!=5" @click="finishRace">Finish
            Run
          </button>
          <button id="finish-live-button" class="btn btn--primary" @click="finishLive" :disabled="CurrentRaceStatus!=6">
            Finish Live
          </button>

          <div class="flex">
              <span id="questionWrapper" class="question flex">
              <div id="leftcolumn">
                  {{ todayQuestion.question }}
              </div>
              <div id="rightcolumn" style="color: #108ee9">
                <a href="javascript: void(0);" @click="showQuestionModalNow(false)" v-if="!isQuestion">Add Question</a>
                <a href="javascript: void(0);" @click="showQuestionModalNow(false)"
                   v-if="isQuestion && isStandBy">Edit</a>
              </div>
            </span>
          </div>

        </div>

        <div class="headertimers">
          <remaining-time></remaining-time>
        </div>
      </div>
    </div>

    <router-link to="/admin/past-run" v-if="this.$props.isPastRun">&#x21A9; Back</router-link>

    <div style="display:flex" v-if="this.$props.isPastRun">
      <p style="font-size: large;padding: 14px 10px 0px 0px;">Recording:</p>
      <div style="min-width: 300px;">
        <audio id="my-audio" v-on:ended="playEnd" controls>
          <source :src="`https://liverun-bucket.s3.amazonaws.com/spreaker-live/live-${this.$route.params.raceId}.mp3`"
                  type="audio/mp3">
        </audio>
      </div>
      <button id="loaddatafb" class="btn btn--primary loadData" style="float: right" @click='fromServer()'
              v-if="this.$props.isPastRun"> Load From Server
      </button>
    </div>

    <div v-if="currentChannel && this.$props.isPastRun" class="channelInfo">
      <div>Channel : {{ channel }}</div>
      <div>{{ currentChannel.id }}</div>
      <div>{{ currentChannel.pwd }}</div>
      <div>{{ currentChannel.desc }}</div>
    </div>

    <br/>

    <!-- Add/Edit Question -->
    <div class="flex" v-if="this.$props.isPastRun">
      <span id="wrapper" class="question">
      <div id="leftcolumn">
          {{ todayQuestion.question }}
      </div>
      <div id="rightcolumn" style="color: #108ee9">
        <a href="javascript: void(0);" @click="showQuestionModalNow(false)" v-if="!isQuestion">Add Question</a>
        <a href="javascript: void(0);" @click="showQuestionModalNow(false)" v-if="isQuestion && isStandBy">Edit</a>
      </div>
    </span>


    </div>

    <sweet-modal ref="quoteOfDay">
      <div class="image">
        <img src="https://contattafiles.s3-us-west-1.amazonaws.com/tnt8888/hIf7gIIFd6jb9AY/q.png" alt="Question"/>
        <h1>Today's Quote</h1>
      </div>
      <textarea v-model="availableQuote" id="Quote" name="quote" Placeholder="Enter Quote Here"></textarea>
      <div>
        <button class="btn btn--primary" v-on:click="SaveQuoteOfDay()" v-if=" !isQuoteOfDayExist" :disabled="isClicked">
          Save
        </button>
        <button class="btn btn--primary" v-on:click="SaveQuoteOfDay()" v-if=" isQuoteOfDayExist" :disabled="isClicked">
          Update
        </button>
      </div>
    </sweet-modal>

    <sweet-modal ref="existingQuote" v-on:close="onSelectNo">
      <p>A quote already exists for this date: <span style="color:red"
                                                     v-if="existingTodayQuote">{{ existingTodayQuote.quote }}</span></p>
      <p>Would you like to update this?</p>
      <br/>
      <div class="flex">
        <div></div>
        <div></div>
        <button class="btn btn--primary" v-on:click="onSelectYes()">Yes</button>
        <button class="btn btn--primary" v-on:click="onSelectNo()">No</button>
        <div></div>
        <div></div>
      </div>
    </sweet-modal>

    <modal-one-signal :race-id="raceIdToNotification" @close-modal="closeOneSignal" v-if="raceIdToNotification"/>
    <!-- Today Question -->
    <race-question :show="showQuestionModal" :raceId="raceId" :todayQuestion="todayQuestion"
                   @saved="onSavedQuestion"></race-question>
    <!-- Today Quote -->
    <quote :show="showQuoteModal" :todayQuote="todayQuote" :isQuoteExist="isQuoteExist" :date='sdate'
           @saved="onSavedQuote" @tapped="test"></quote>
    <!-- Date-Selector -->
    <date-picker v-model="sdate" :date='sdate' :showActionButtons='false' ref="modal" @change="onChangeDate"
                 v-if="tapped"></date-picker>

  </header>
</template>

<script>


var RaceStatus = {
  "New": 1,
  "Standby": 2,
  "Live": 3,
  "StartRun": 4,
  "FinishRun": 5,
  "FinishLive": 6,
  "Ended": 7
}

let dialogOptions = {
  html: true, // set to true if your message contains HTML tags. eg: "Delete <b>Foo</b> ?"
  loader: false, // set to true if you want the dailog to show a loader after click on "proceed"
  reverse: false, // switch the button positions (left to right, and vise versa)
  cancelText: 'No',
  okText: 'Yes',
  animation: 'zoom', // Available: "zoom", "bounce", "fade"
  type: 'basic', // coming soon: 'soft', 'hard'
  verification: 'continue', // for hard confirm, user will be prompted to type this to enable the proceed button
  clicksCount: 3,
  animation: 'bounce', // for soft confirm, user will be asked to click on "proceed" btn 3 times before actually proceeding
}

let dialogOpt = {
  cancelText: 'Cancel',
  okText: 'Ok',
}

import Pace from '@/utils/calculation/Pace'
import RaceResumeService from '@/services/raceResume'
import RaceQuestionService from '@/services/raceQuestion'
import DatePicker from '@/components/DatePicker/DatePicker'
import RemainingTime from './RemainingTime'
import RaceQuestion from './Question'
import Quote from './Quote'
import Vue from "vue"
import VuejsDialog from "vuejs-dialog"
import ModalOneSignal from '@/components/ModalOneSignal'
import {SweetModal} from 'sweet-modal-vue'
import service from '@/services/index'

const getRace = service.resource('races{/id}')
const resource = service.resource('races/upload-audio-file')
// Tell Vue to install the plugin.
Vue.use(VuejsDialog)
import moment from 'moment'
import {
  mapGetters,
  mapActions
} from 'vuex'
import {
  db
} from '../../../firebase'
import {project, descend, prop, sort} from 'ramda'
import axios from 'axios'
import RunnersByRaceService from '../../../services/runnersByRace'
import Recorder from 'record-audio-js'

let intervalPace = null
let runnersFirebase = []
let timeLeftInterval
export default {
  name: 'race-header',
  data: () => ({  
    autopilotTooltip: 'This race is configured to run in autopilot mode',
    audioFileNotFound: false,
    isRecording: false,
    mic: '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32"><path id="svg_1" d="m16,20a6,6 0 0 0 6,-6l0,-6a6,6 0 0 0 -12,0l0,6a6,6 0 0 0 6,6z"/><path id="svg_2" d="m26,14a1,1 0 0 0 -2,0a8,8 0 0 1 -16,0a1,1 0 0 0 -2,0a10,10 0 0 0 9,9.95l0,4.05l-4,0a1,1 0 0 0 0,2l10,0a1,1 0 0 0 0,-2l-4,0l0,-4.05a10,10 0 0 0 9,-9.95z"/></g></svg><p>Recording Live Streaming...</p>',
    nomic: '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32"><path id="svg_1" d="m9,9.41l0,4.59a6,6 0 0 0 9.47,4.89l1.43,1.43a8,8 0 0 1 -12.9,-6.32a1,1 0 0 0 -2,0a10,10 0 0 0 9,9.95l0,4.05l-4,0a1,1 0 0 0 0,2l10,0a1,1 0 0 0 0,-2l-4,0l0,-4.05a10,10 0 0 0 5.32,-2.21l6,6a1,1 0 0 0 1.41,-1.41l-6,-6a10,10 0 0 0 2.27,-6.33a1,1 0 0 0 -2,0a8,8 0 0 1 -1.69,4.9l-1.43,-1.43a6,6 0 0 0 1.12,-3.47l0,-6a6,6 0 0 0 -11.86,-1.27l-4.43,-4.44a1,1 0 0 0 -1.42,1.42l5.71,5.7zm6,8.59a4,4 0 0 1 -4,-4l0,-2.59l6,6a4,4 0 0 1 -2,0.59zm-4,-10a4,4 0 0 1 8,0l0,6a4,4 0 0 1 -0.57,2l-7.43,-7.41l0,-0.59z"/></g></svg><p>No Mic Found !</p>',
    tapped: false,
    textActionButton: '',
    textLiveButton: '',
    statusLive: false,
    raceFirebase: {},
    loadingUpdate: false,
    el: '#app',
    due: '2017-01-01',
    mydate: new Date(),
    date(date) {
      return moment(date).format('YYYY/MM/DD')
    },
    sdate: {
      time: moment().format('YYYY-MM-DD')
    },
    showModal: false,
    remainingTime: '00:00:00',
    startDate: Date.now,
    counter: 0,
    my_timer: 0,
    showQuestionModal: false,
    showQuoteModal: false,
    CurrentRaceStatus: 2,
    todayQuestion: {},
    todayQuote: {
      date: null,
      id: null,
      quote: null
    },
    isQuestion: false,
    QuoteOfDay: '',
    availableQuote: '',
    isQuoteExist: false,
    isQuoteOfDayExist: false,
    isClicked: false,
    raceId: null,
    isStandBy: true,
    hasQuestion: false,
    raceIdToNotification: null,
    isStartLive: false,
    raceStartHours: 0,
    raceStartMinutes: 0,
    totalHoursLeft: 0,
    minutesLeft: 0,
    secondsLeft: 0,
    raceStarted: false,
    time: null,
    existingTodayQuote: null,
    availableTodayQuote: null,
    rec: null,
    audioChunks: [],
    micError: null,
    micInterval: null,
    isPlay: false,
    recording: null,
    autopilotTooltip: 'This race will automatically start at the scheduled time and perform all run process actions without manual intervention. It will end at the scheduled time based on the configured duration.',
    audio: null,
    myAudioChunk: [],
    channel: '',
    statusFB: '',
    liveStatusFB: '',
    standByFB: '',
    channelInfo: {
      "A": {
        'id': "takada@liverunapp.com",
        'pwd': "Tokyo2020",
        'desc': "LR Channel 1"
      },
      'B': {
        'id': "tomo.takada@gmail.com",
        'pwd': "Tokyo2020",
        'desc': "LRCh2"
      },
      'C': {
        'id': "tomo.takada@gmail.com",
        'pwd': "Tokyo2020"
      }
    },
    currentChannel: ''
  }),
  props: {
    isPastRun: Boolean
  },
  computed: {
    ...mapGetters({
      race: 'Race/race',
      trainer: 'Trainer/trainer',
      //runner:'Runners/runners',
      template: '#modal-template',
      runners: 'Race/runners',
      question: 'RaceQuestion/question',
      // template: '#bs-modal'
    }),
    isAutoPilotRace() {
      return this.race && this.race.description && this.race.description.includes('AutoPilot');
    }
  },

  methods: {
    startAutoRun() {
      // Call the auto run service to start the auto run process
      this.$store.dispatch('Race/startAutoRun', this.race.id)
        .then(() => {
          this.$notify({
            group: 'notifications',
            title: 'Auto Run Started',
            text: 'The auto run process has been initiated',
            type: 'success'
          });
        })
        .catch(error => {
          this.$notify({
            group: 'notifications',
            title: 'Error',
            text: 'Failed to start auto run: ' + error.message,
            type: 'error'
          });
        });
    },

    test: function (e) {
      this.tapped = e
      let that = this
      setTimeout(() => {
        that.$refs.modal.showCheck()
      }, 200)

    },
    onChangeDate(e) {
      this.getRaceQuote(e).then((e) => {
        if (e.data) {
          this.$refs.existingQuote.open()
          this.existingTodayQuote = e.data

        } else {
          // this.todayQuote = {
          //                 date:null,
          //                 id:null,
          //                 quote:null
          //               },
          // this.sdate.time =  moment().format('YYYY-MM-DD')

          this.isQuoteExist = false
        }
      })
        .catch(() => {
          console.log('failed')
        })
    },
    onSelectYes() {
      this.$refs.existingQuote.close()
      console.log(this.existingTodayQuote)
      this.todayQuote = this.existingTodayQuote
      this.sdate.time = this.existingTodayQuote.date
      this.isQuoteExist = true
    },
    onSelectNo() {
      this.$refs.existingQuote.close()
      this.sdate.time = moment().format('YYYY-MM-DD')

    },
    loadrunners() {
      this.loaddata()
    },
    showQuoteOfDayModalNow() {
      this.availableQuote = this.QuoteOfDay
      this.$refs.quoteOfDay.open()
    },
    async SaveQuoteOfDay() {
      console.log("availableQuote", this.availableQuote)
      this.isClicked = true
      let updatedRace = await getRace.get({id: this.$route.params.raceId})
      updatedRace.data.quoteOfDay = this.availableQuote
      this.updateRace(updatedRace.data).then((obj) => {
        console.log("obj>>>", obj)
        this.getQuoteOfDay()
        this.$refs.quoteOfDay.close()
        this.isClicked = false

      })
        .catch(() => {
          console.log('failed')
          this.getQuoteOfDay()
          this.$refs.quoteOfDay.close()
          this.isClicked = false
        })
    },
    // async UpdateQuoteOfDay(){
    //   console.log("UpdateQuoteOfDay",this.QuoteOfDay)
    // },

    async getQuoteOfDay() {
      var racedata = await getRace.get({id: this.$route.params.raceId})
      console.log("getQuoteOfDay--->>>", racedata.data.quoteOfDay)

      if (racedata.data.quoteOfDay && racedata.data.quoteOfDay != null) {
        console.log("quote Exist")
        this.isQuoteOfDayExist = true
        this.QuoteOfDay = racedata.data.quoteOfDay
      } else {
        console.log("quote not Exist")
        this.isQuoteOfDayExist = false
        this.QuoteOfDay = ''
      }
    },

    async getChannel() {
      var racedata = await getRace.get({id: this.$route.params.raceId})
      if (racedata.data && racedata.data.mobileChannelToPlay) {
        switch (racedata.data.mobileChannelToPlay.trim()) {
          case 'https://api.spreaker.com/v2/episodes/18340960/play':
            this.channel = 'A'
            this.currentChannel = this.channelInfo.A
            break
          case 'https://api.spreaker.com/v2/episodes/20496650/play':
            this.channel = 'B'
            this.currentChannel = this.channelInfo.B
            break
          case 'https://edge.mixlr.com/channel/ygdpy':
            this.channel = 'C'
            this.currentChannel = this.channelInfo.C
            break
        }
      }
    },

    getQuote() {
      if (this.$props.isPastRun && this.race.finishDate) {
        this.getRaceQuote(moment(this.race.startDate).format('YYYY-MM-DD')).then((e) => {
          this.availableTodayQuote = e.data.quote
        })
      } else {
        this.getRaceQuote(moment().format('YYYY-MM-DD')).then((e) => {
          if (e.data) {
            this.todayQuote = e.data
            this.availableTodayQuote = e.data.quote
            this.isQuoteExist = true
          } else {
            this.isQuoteExist = false
          }
        })
          .catch(() => {
            console.log('failed')
          })
      }


    },

    fromServer() {
      this.$router.push({
        name: 'past-run',
        params: {pastRun: true, raceId: this.$route.params.raceId}
      })
    },
    date(date) {
      return moment(date).format('YYYY/MM/DD')
    },
    closeOneSignal() {
      this.raceIdToNotification = null
    },
    openNotification(raceId) {
      this.raceIdToNotification = raceId
    },
    onSavedQuestion(value) {
      this.showQuestionModal = false
      this.getQuestion()
    },
    onSavedQuote(value) {
      this.showQuoteModal = false
      this.tapped = false
      this.getQuote()
    },
    showQuestionModalNow(event) {
      this.hasQuestion = event
      this.showQuestionModal = true
      this.raceId = this.$route.params.raceId
    },
    showQuoteModalNow(event) {
      // this.todayQuote = {
      //                           date:null,
      //                           id:null,
      //                           quote:null
      //                         },
      // this.sdate.time =  moment().format('YYYY-MM-DD')
      this.showQuoteModal = true
    },
    async initialize() {
      //**Stop updating status/statusLive/current value in Firebase before the start of race
      await db.ref(`/${this.$fbDbEntry}/${this.$route.params.raceId}`).once('value', (raceFirebase) => {
        var raceFb = raceFirebase.val()
        if (raceFb != null && raceFb != undefined) {
          if (raceFb.statusLive && raceFb.statusLive == 'finished' &&
            raceFb.status && raceFb.status == 'finished') {
            if ((raceFb.raceResumeId == undefined || raceFb.raceResumeId == null) &&
              (raceFb.startDateTime == undefined || raceFb.startDateTime == null)) {
              console.log("********add prevention here 1 !!!***********")
              db.ref(`/${this.$fbDbEntry}/${this.$route.params.raceId}/statusLive`).remove()
              db.ref(`/${this.$fbDbEntry}/${this.$route.params.raceId}/status`).remove()
              db.ref(`/${this.$fbDbEntry}/${this.$route.params.raceId}/currentTime`).remove()
            }
          } else if (raceFb.statusLive == 'finished' &&
            (raceFb.raceResumeId == undefined || raceFb.startDateTime == undefined)) {
            console.log("********add prevention here 2 !!!***********")
            db.ref(`/${this.$fbDbEntry}/${this.$route.params.raceId}/statusLive`).remove()
          } else if (raceFb.currentTime != undefined && raceFb.raceResumeId == undefined) {
            console.log("********add prevention here 3 !!!***********")
            db.ref(`/${this.$fbDbEntry}/${this.$route.params.raceId}/currentTime`).remove()
          }
        }
      })

      var that = this
      var sminutes = 0
      this.timeLeftInterval = setInterval(function () {

        var date_future = new Date(that.race.date)
        var date_now = new Date()
        var seconds = Math.floor((date_future - (date_now)) / 1000)
        var minutes = Math.floor(seconds / 60)
        sminutes = Math.floor(seconds / 60)
        var hours = Math.floor(minutes / 60)
        var days = Math.floor(hours / 24)
        // hours = hours-(days*24)
        minutes = minutes - (days * 24 * 60) - (hours * 60)
        seconds = seconds - (days * 24 * 60 * 60) - (hours * 60 * 60) - (minutes * 60)
        that.totalHoursLeft = hours
        that.minutesLeft = sminutes
        that.secondsLeft = seconds
        if (that.CurrentRaceStatus === 5 || sminutes < 0) {
          that.raceStarted = true
          clearInterval(that.timeLeftInterval)
        }

      }, 1000)

      this.$on('closed', () => { //WHEN MODAL IS CLOSED
        if (this.hasQuestion) {
          db.ref(`/${this.$fbDbEntry}/${this.$route.params.raceId}`).update({
            'standBy': false
          })
          this.showQuestionModal = false
          this.CurrentRaceStatus = RaceStatus.Live
        }
      })

    },

    standBy() {
      var that = this
      db.ref(`/${this.$fbDbEntry}/${this.$route.params.raceId}`).update({
        'standBy': false
      }).then(function () {
        that.CurrentRaceStatus = RaceStatus.Live
      }).catch(function (error) {
        console.log(error)
      })
    },
     confirmStartRace() {
      console.log("********confirmStartRace**********")
      let race = {
        status: 'running',
        runners: [],
        // raceResumeId: '' //THIS CAUSES FIREBASE TO LOSE THE ID ON RACE RESUME
      }
      //this.$dialog.confirm("ランニングを開始しますか？", dialogOptions)
      this.$dialog.confirm("ランニングを開始しますか？<br>Do you want to start run?", dialogOptions)
        .then(async (dialog) => {
          this.textActionButton = 'Starting...'

          await db.ref(`/${this.$fbDbEntry}/${this.$route.params.raceId}`).update({
            'status': 'StartRun'
          })

          console.log("RACE STATUS SET TO STTART RUN  IN FIREBASE **********");

          this.loadingUpdate = true
          //  db.ref(`/${this.$fbDbEntry}/${this.$route.params.raceId}`).update({
          //     'status': 'running'
          //   })
          _LTracker.push('Race::: ' + this.$route.params.raceId + ' Started By Trainer: ' + this.$auth.user().id + ' isStage :' + this.$isStage)
          return this.$store
            .dispatch('Race/start', this.$route.params.raceId)
            .then(async () => {
              var raceResumesByRace = ''
              await RaceResumeService.getRaceResumesByRace(this.$route.params.raceId)
                .then((data) => {
                  raceResumesByRace = data
                })
              if (raceResumesByRace != undefined && raceResumesByRace.body != '' && raceResumesByRace.body != undefined) {
                return raceResumesByRace
              } else {
                const raceResume = {
                  totalAmountRunners: this.runners.length,
                  startDate: new Date().toISOString(),
                  race: this.race
                }
                return this.createRaceResume(raceResume)
              }
              // const raceResume = {
              //   totalAmountRunners: this.runners.length,
              //   startDate: new Date().toISOString(),
              //   race: this.race
              // }
              // return this.createRaceResume(raceResume)
            })
            .then((raceResumeResult) => {
              db.ref(`/${this.$fbDbEntry}/${this.$route.params.raceId}`).update({
                'raceResumeId': raceResumeResult.body.id,
                //'startDateTime': Date.now(),  //NOW UPDATE STARTDATETIME FROM SERVER SIDE TO PREVENT EXTRA 30 SEC ADDED ISSUE
              })

            })
            .then(() => {
              this.loadingUpdate = false
              this.textActionButton = 'Finish Race'
              this.CurrentRaceStatus = RaceStatus.FinishRun
            }).catch((err) => {
              alert("インターネットに接続されていません。")
              window.location.reload()
              console.log('Start Run aborted', err)
            })

        })
        .catch(() => {
          // Triggered when cancel button is clicked
          console.log('Start Run aborted')
        })
    },

    //FUNCTION TO START THE RUN/RACE
    startRace() {
      //console.log("minutesLeft---",this.minutesLeft)
      if (this.minutesLeft > 2) {
        //console.log("more than 2 min")

        //var confirmation = confirm("本当にスタートランをしていいですか？")
        var confirmation = confirm("本当にスタートランをしていいですか？ \n Do you really want to start run ?")
        if (confirmation == true) {
          //console.log("You pressed OK!")
          this.confirmStartRace()
        }

      } else {
        //console.log("less than 2 min")
        this.confirmStartRace()
      }
    },
    convertHoursToHuman(secondsToConvert) {
      let hours = Math.floor((secondsToConvert % 86400) / 3600)
      // let minutes = Math.floor((secondsToConvert % 86400) % 3600 / 60)
      let minutes = Math.floor(secondsToConvert / 60)
      let seconds = secondsToConvert % 60 < 10 ? `0${secondsToConvert % 60}` : secondsToConvert % 60

      hours = hours < 10 ? `0${hours}` : hours
      minutes = minutes < 10 ? `0${minutes}` : minutes

      return `${minutes}`
    },
    //FUNCTION USED TO END/FINISH THE RACE/RUN
    finishRace() {
      db.ref(`/${this.$fbDbEntry}/${this.$route.params.raceId}/currentTime`)
        .once('value', (snapshot) => {
          this.currentTime = snapshot.val()
          //console.log("this.currentTime--->>>",this.currentTime)
          if (this.currentTime > -1) {
            this.remainingTime = this.convertHoursToHuman(this.currentTime)
            console.log("remainingTime---", this.remainingTime)
            if (this.remainingTime > 2) {
              console.log("more than 2 min")

              // confirmation = confirm("これを押すとランが終了します！本当にいいですか？")
              var confirmation = confirm("これを押すとランが終了します！本当にいいですか？\nPress this to end the run! Is it really okay?")
              if (confirmation == true) {
                this.confirmFinishRace()
              }
            } else {
              console.log("less than 2 min")
              this.confirmFinishRace()
            }
          } else {
            this.confirmFinishRace()
          }
        })
      // this.$dialog.confirm("ランニングを終了しますか？", dialogOptions)
      //   .then((dialog) => {
      //    this.endRace()
      //   })
    },
    confirmFinishRace() {
      //this.$dialog.confirm("ランニングを終了しますか？", dialogOptions)
      this.$dialog.confirm("ランニングを終了しますか？ <br> Do you want to finish run ?", dialogOptions)
        .then((dialog) => {
          this.endRace()
        })
    },

    async endRace() {
      _LTracker.push('Race::: ' + this.$route.params.raceId + ' Finished By Trainer: ' + this.$auth.user().id + ' isStage :' + this.$isStage)
      db.ref(`/${this.$fbDbEntry}/${this.$route.params.raceId}`).update({
        'status': 'finished'
      })
      let resumeId = await db.ref(`/${this.$fbDbEntry}/${this.$route.params.raceId}/raceResumeId`).once('value')
      let raceResumeId = resumeId.val()

      //let raceResumeId = this.raceFirebase.raceResumeId
      console.log("raceResumeId----", raceResumeId)
      let that = this
      return RaceResumeService.get(raceResumeId)
        .then((data) => {
          let fbRunners = []
          db.ref(`/${this.$fbDbEntry}/${this.$route.params.raceId}/runners`)
            .once('value', (runnerFirebase) => {
              if (runnerFirebase.val()) {
                const snap = runnerFirebase.val()
                Object.keys(snap).forEach((key) => {
                  snap[key].id = key
                  fbRunners.push(snap[key])
                })
              }
            })
          const raceResume = {
            id: data.body.id,
            finishDate: new Date().toISOString(),
            startDate: data.body.startDate,
            race: data.body.race,
            totalAmountRunners: fbRunners.length
          }

          RaceResumeService.update(raceResume)
            .then(() => {
              db.ref(`/${this.$fbDbEntry}/${this.$route.params.raceId}`).update({
                'status': 'finished'
              })
              this.textActionButton = 'Finishing...'
              this.loadingUpdate = true
              return this.$store
                .dispatch('Race/finish', this.$route.params.raceId)
                .then(() => {
                  this.loadingUpdate = false
                  this.textActionButton = 'Finish Race'
                  //UPDATE BUTTONS
                  this.CurrentRaceStatus = RaceStatus.FinishLive
                  _LTracker.push('Race::: ' + this.$route.params.raceId + ' Finished Time Updated  By Trainer: ' + this.$auth.user().id + ' isStage :' + this.$isStage)
                }).catch((e) => {
                  console.log("errr--->>", e)
                  this.retryFinishRace(this.$route.params.raceId)
                })

            })

        })
        .catch(function (error) {
          // This will be triggered when user clicks on cancel
          console.log(error)
          console.log('We are not able to find raceresume Id Still we are trying to finish the current race!')
          that.CurrentRaceStatus = RaceStatus.FinishLive
        })
    },

    retryFinishRace(raceId) {
      console.log("ReTry finish race")
      this.$store.dispatch('Race/finish', raceId).then(() => {
        _LTracker.push('Race::: ' + raceId + ' Finished Time Updated  By Trainer: ' + this.$auth.user().id)
      }).catch((e) => {
        console.log("again errr---", e)
      })
    },

    resetTimer() {
      clearInterval(this.my_timer)
    },
    timerFormat(timer) {
      return timer > 9 ? timer : '0' + timer
    },
    startLive() {
      if (this.minutesLeft >= 30) {
        var confirmation = confirm("本当にライブを開始していいですか？ \nAre you sure you want to start Live? ?")
        if (confirmation == true) {
          this.confirmStartLive()
        }
      } else {
        this.confirmStartLive()
      }
    },

    confirmStartLive() {
      this.$dialog.confirm("ライブを開始しますか？<br>Do you want to start live?", dialogOptions)
        .then((dialog) => {

          //this.audioChunks = []
          // try{
          //   this.rec.start()
          // }catch(err){
          //   console.log('Mic not found!')
          // }

          // try{
          //  this.startRecording()
          // }catch(err){
          //   console.log('err---',err)
          // }

          //this.isRecording = true
          db.ref(`/${this.$fbDbEntry}/${this.$route.params.raceId}`).update({
            'statusLive': 'started',
            'standBy': false
          })
          _LTracker.push('Race::: ' + this.$route.params.raceId + ' Live Started By Trainer: ' + this.$auth.user().id + ' isStage :' + this.$isStage)
          //Update status Live in Server
          this.updateStatusLive(this.$route.params.raceId)
          this.CurrentRaceStatus = RaceStatus.StartRun
          this.$store.dispatch("Race/startLive")


          setTimeout(() => {
            console.log('Start Live Continue.')
          }, 100)
        })
        .catch(() => {
          // Triggered when cancel button is clicked
          console.log('Start Live aborted.')
        })
    },


    async finishLive() {
      let updatedRace = await getRace.get({id: this.$route.params.raceId})
      //console.log("race--->",updatedRace.data)
      //console.log("finishDate-->",updatedRace.data.finishDate)
      //console.log("date-->", new Date().toISOString())

      var currentTime = new Date(),
        finishTime = new Date(updatedRace.data.finishDate)

      var diff = currentTime - finishTime
      //console.log("diff-->>>>>", diff)

      if (diff > 60e3) {
        var min = Math.floor(diff / 60e3)
        console.log(min, 'minutes ago')
        if (min > 2) {
          console.log("more than 2 min")
          this.confirmFinishLive()
        } else {
          console.log("less than 2 min")
          //var confirmation = confirm("ランナーに音が全く聞こえなくなります、本当にいいですか？")
          var confirmation = confirm("ランナーに音が全く聞こえなくなります、本当にいいですか？\nRunners won't be able to hear your live. Is it okay ?")
          if (confirmation == true) {
            this.confirmFinishLive()
          }
        }
      } else {
        var sec = Math.floor(diff / 1e3)
        console.log(Math.floor(diff / 1e3), 'seconds ago')
        //console.log("less than sec")
        //var confirmation = confirm("ランナーに音が全く聞こえなくなります、本当にいいですか？")
        var confirmation = confirm("ランナーに音が全く聞こえなくなります、本当にいいですか？\nRunners won't be able to hear your live. Is it okay ?")
        if (confirmation == true) {
          this.confirmFinishLive()
        }
      }

    },
    confirmFinishLive() {

      //this.$dialog.confirm("ライブ配信を終了しますか？", dialogOptions)
      this.$dialog.confirm("ライブ配信を終了しますか？<br> Do you want to finish live ?", dialogOptions)
        .then(async (dialog) => {
          //  try{
          //     console.log('ON STOP--->',this.rec)
          //     this.rec.stop()
          //  }catch(err){
          //    console.log("stop rec error---",err)
          //  }

          //  try{
          //    console.log('ON STOP--->',this.rec)
          // this.rec.stop()
          // clearInterval(this.micInterval)
          //  }catch(err){
          //    console.log(err)
          //  }
          // await this.stopRecording()
          // console.log("outtt")
          // this.isRecording =  false
          db.ref(`/${this.$fbDbEntry}/${this.$route.params.raceId}`).update({
            'statusLive': 'finished'
          })
          _LTracker.push('Race::: ' + this.$route.params.raceId + ' Live Finished By Trainer: ' + this.$auth.user().id + ' isStage :' + this.$isStage)
          this.$store.dispatch("Race/stopLive")
          this.CurrentRaceStatus = RaceStatus.Ended

        })

    },
    async updateButtons() {
      console.log("Firebase updated, checking buttons in updateButtons")
      let racestatus = await db.ref(`/${this.$fbDbEntry}/${this.$route.params.raceId}/status`).once('value')
      let status = racestatus.val()
      let raceStatusLive = await db.ref(`/${this.$fbDbEntry}/${this.$route.params.raceId}/statusLive`).once('value')
      let statusLive = raceStatusLive.val()

      if (statusLive === undefined) {
        this.isStandBy = true
      } else if (statusLive === 'started' || statusLive === 'finished') {
        this.isStandBy = false
      }


      // if(this.raceFirebase.statusLive === undefined){
      //     this.isStandBy = true
      // }else if(this.raceFirebase.statusLive === 'started' || this.raceFirebase.statusLive === 'finished'){
      //   this.isStandBy = false
      // }

      // let status = this.raceFirebase.status
      // let statusLive = this.raceFirebase.statusLive
      if (statusLive) {
        this.isStartLive = true
      }

      //let statusStandBy = this.raceFirebase.standBy
      let raceStatusStandBy = await db.ref(`/${this.$fbDbEntry}/${this.$route.params.raceId}/standBy`).once('value')
      let statusStandBy = raceStatusStandBy.val()

      if (statusStandBy === false) {
        this.CurrentRaceStatus = RaceStatus.Live
      }

      if (status === "running") {
        this.raceStarted = true
        this.CurrentRaceStatus = RaceStatus.FinishRun
      }
      if (status === "finished") {
        this.CurrentRaceStatus = RaceStatus.FinishLive
      }
      if (statusLive === "started" && status != "running" && status != "finished") {
        this.CurrentRaceStatus = RaceStatus.StartRun
      }
      if (statusLive === "finished") {
        this.CurrentRaceStatus = RaceStatus.Ended
      }
    },

    handleClickLiveButton() {
      this[this.getFunctionLiveButton()]()
    },

    getQuestion() {
      this.$store.dispatch('RaceQuestion/getOne', this.$route.params.raceId).then(() => {
        this.todayQuestion = this.question
        if (this.question.id) {
          this.isQuestion = true
        } else {
          this.isQuestion = false
        }
      })
    },
    //  play() {
    //   var myAudio = document.getElementById('my-audio')
    //   myAudio.load()
    //   myAudio.play()
    //   this.isPlay = true
    // },
    // pause() {
    //   var myAudio = document.getElementById('my-audio')
    //   myAudio.load()
    //   myAudio.pause()
    //   this.isPlay = false
    // },
    // downloadItem(url) {
    //   axios.get(url, {
    //       responseType: 'blob'
    //     })
    //     .then(({
    //       data
    //     }) => {
    //       const blob = new Blob([data], {
    //         type: 'audio/mp3'
    //       })
    //       let link = document.createElement('a')
    //       link.href = window.URL.createObjectURL(blob)
    //       link.download = `${this.race.id}.mp3`
    //       link.click()
    //         .catch(error => console.error(error))
    //     })
    // },
    play() {
      var myAudio = document.getElementById('my-audio')
      //myAudio.load()
      myAudio.play()
      this.isPlay = true
    },
    pause() {
      var myAudio = document.getElementById('my-audio')
      //myAudio.load()
      myAudio.pause()
      this.isPlay = false
    },
    playEnd() {
      this.isPlay = false
    },
    downloadItem() {
      var url = `https://liverun-bucket.s3.amazonaws.com/spreaker-live/live-${this.$route.params.raceId}.mp3`
      axios.get(url, {
        responseType: 'blob'
      })
        .then(({
                 data
               }) => {
          const blob = new Blob([data], {
            type: 'audio/mp3'
          })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = `${this.race.id}.mp3`
          link.click()
        })
    },
    checkAudioUrl() {
      var that = this
      $.ajax({
        url: `https://liverun-bucket.s3.amazonaws.com/spreaker-live/live-${this.$route.params.raceId}.mp3`,
        error: function () {
          that.audioFileNotFound = true
        },
        success: function () {
          that.audioFileNotFound = false
        }
      })
    },
    async sendData(file) {
      let formData = new FormData()
      formData.append('file', file)
      const mp3 = await resource.save(formData)
      console.log("mp3---", mp3)
      let updatedRace = await getRace.get({id: this.$route.params.raceId})
      /*GET THE SAVED MP3 URL FROM SERVER */
      updatedRace.data.audioFileUrl = mp3.data.url

      /* UPDATE THE URL TO RACE SESSION */
      try {
        await this.updateRace(updatedRace.data)
        console.log("data updated")
      } catch (err) {
        console.log(err)
      }

    },
    // reloadPage(){
    //   //1.Stop the recording
    //   this.rec.stop()

    //   //2. Reload the page
    //   setTimeout(()=>{
    //     location.reload()
    //   },1000)
    // },
    initializeUserMedia() {
      let that = this
      navigator.mediaDevices.getUserMedia({audio: true})
        .then(stream => {
          console.log('mic for you!')
          that.micError = null
          //that.handlerFunction(stream)
        }).catch(function (err) {
        that.micError = 'Mic not found!'
        /*Call function again if mic is not available */
        setTimeout(() => {
          that.initializeUserMedia()
        }, 1000)
        console.log('No mic for you!', err)
      })
    },
    // b64toBlob(dataURI) {
    //   var byteString = atob(dataURI.split(',')[1])
    //   var ab = new ArrayBuffer(byteString.length)
    //   var ia = new Uint8Array(ab)

    //   for (var i = 0; i < byteString.length; i++) {
    //       ia[i] = byteString.charCodeAt(i)
    //   }
    //   return new Blob([ab], { type: 'audio/webm;codecs=opus' })
    // },
    // async handlerFunction(stream){
    //       this.rec = new MediaRecorder(stream)
    //       let that = this
    //       //check if race is started or not finished live
    //       let finishLiveStatus = await db.ref(`/${this.$fbDbEntry}/${this.$route.params.raceId}/statusLive`).once('value')
    //       finishLiveStatus = finishLiveStatus.val()?finishLiveStatus.val():null

    //       if(finishLiveStatus != null && finishLiveStatus!= 'finished' && this.rec.state == "inactive"){
    //             this.rec.start()
    //             this.isRecording =true
    //       }

    //       this.rec.ondataavailable = async e => {
    //           const oldAudio = localStorage.getItem('audio')
    //           if(oldAudio){
    //             this.audioChunks=JSON.parse(oldAudio)
    //           }
    //           var reader = new FileReader()
    //           reader.readAsDataURL(e.data)
    //           reader.onloadend = async function() {
    //               var base64data = reader.result
    //               that.audioChunks.push(base64data.toString())
    //               localStorage.setItem('audio', JSON.stringify(that.audioChunks))
    //               let finishLiveStatus = await db.ref(`/${that.$fbDbEntry}/${that.$route.params.raceId}/statusLive`).once('value')
    //               finishLiveStatus = finishLiveStatus.val()?finishLiveStatus.val():null
    //               if (that.rec.state == "inactive" && finishLiveStatus ==='finished'){
    //                   let newChunk = []
    //                   that.audioChunks.forEach(base64 => {
    //                       newChunk.push(that.b64toBlob(base64))
    //                   })
    //               try{
    //                   let blob = new Blob(newChunk,{type:'audio/mp3'})
    //                   var file = new File([blob], 'audio.mp3', {type: 'audio/mp3', lastModified: Date.now()})
    //                   that.sendData(file)
    //                   localStorage.removeItem('audio')
    //                 }catch(err){
    //                   localStorage.removeItem('audio')
    //                 }
    //               }
    //           }
    //       }
    // },
    async emptyAudioUrl() {
      let updatedRace = await getRace.get({id: this.$route.params.raceId})
      /*GET THE SAVED MP3 URL FROM SERVER */
      updatedRace.data.audioFileUrl = ""

      /* UPDATE THE URL TO RACE SESSION */
      try {
        await this.updateRace(updatedRace.data)
      } catch (err) {
        console.log(err)
      }
    },
    async startRecording() {
      var that = this


      // this.audio = new Audio("https://api.spreaker.com/v2/episodes/18340960/play")
      // this.audio.crossOrigin = 'anonymous'
      // this.audio.play()
      // const ctx = new (window.AudioContext || window.webkitAudioContext)()
      // const stream_dest = ctx.createMediaStreamDestination()
      // const source = ctx.createMediaElementSource(this.audio)
      // source.connect(stream_dest)
      // const stream = stream_dest.stream
      // console.log("stream----",stream)


      this.audio = document.getElementById('live-streaming')
      this.audio.play()
      console.log("this.audio.captureStream()--", this.audio.captureStream())
      this.rec = new MediaRecorder(stream)
      this.rec.start()
      this.isRecording = true
      this.rec.ondataavailable = async e => {
        console.log("e.data---", e.data)
        that.audioChunks.push(e.data)
        if (that.rec.state == "inactive") {
          that.isRecording = false
          let blob = new Blob(that.audioChunks, {type: 'audio/mp3'})
          var file = new File([blob], 'audio.mp3', {type: 'audio/mp3', lastModified: Date.now()})
          that.sendData(file)
          that.audio.pause()
        }
      }

      // console.log("audio--",audio.captureStream())
      // let audioCtx = new AudioContext()
      // let source = audioCtx.createMediaElementSource(audio)
      // console.log("source--",source)
      // source.connect(audioCtx.destination)
      // this.recording = new Recorder(source)
      // console.log("recording--",this.recording)
      // this.recording.record()
    },
    stopRecording() {
      this.rec.stop()
    },
    //stopRecording(){
    //  let that = this
    //   console.log("stop rec",this.recording)
    //   if(this.recording == null) return
    //   that.recording.stop()
    //   that.audio.pause()
    //   console.log("this.recording---",that.recording)
    //   return new Promise((resolve, reject) => {
    //   that.recording.exportWAV(async function(blob){
    //         console.log("blob---",blob)
    //   let formData = new FormData()
    //   formData.append('file', blob,'audio.mp3')
    //   formData.append('raceId',that.$route.params.raceId)
    //   formData.append('token', 'Bearer '.concat(window.localStorage.getItem('default-auth-token')))
    //   console.log("formData---",formData)

    //   //send data to server side
    //   axios({
    //       method: 'post',
    //       url: 'http://localhost:3005/audio-url',
    //       data: formData,
    //        config: { headers: {'Content-Type': 'multipart/form-data' }}
    //   })
    //   .then(function (response) {
    //     //handle success
    //      console.log("respp---",response)
    //   })
    //   .catch(function (response) {
    //     //handle error
    //     console.log("errrorr---",response)
    //    })


    //         //that.myAudioChunk.push(blob)
    //         //console.log("myAudioChunk--",that.myAudioChunk)
    //         //let newblob = new Blob(that.myAudioChunk,{type:'audio/mp3'})
    //         //var file = new File([blob], 'audio.mp3', {type: 'audio/mp3', lastModified: Date.now()})
    //         //await that.sendData(blob)
    //         resolve()
    //       })
    //     })
    // },
    ...mapActions({
      createRaceResume: 'RaceResume/createOne',
      updateStatusLive: 'Race/updateStatusLive',
      getRaceQuote: 'RaceQuote/getOne',
      updateRace: 'Race/updateOne',
    })
  },
  watch: {
    race() {
      this.time = moment(this.race.date).format('LT')
    },

    // raceFirebase() {
    //   this.updateButtons()
    // },
    statusFB() {
      this.updateButtons()
    },
    liveStatusFB() {
      this.updateButtons()
    },
    standByFB() {
      this.updateButtons()
    },
    CurrentRaceStatus() {
    },
    sdate() {
      console.log(this.sdate)
    }

  },
  created() {
    var interval
    this.getQuote()
    this.initialize()
    this.getChannel()
    this.checkAudioUrl()
    //this.initializeUserMedia()
    this.getQuestion()
    this.updateButtons()
    //this.$bindAsObject('raceFirebase', db.ref(`/${this.$fbDbEntry}/${this.$route.params.raceId}`))
    this.$bindAsObject('statusFB', db.ref(`/${this.$fbDbEntry}/${this.$route.params.raceId}/status`))
    this.$bindAsObject('liveStatusFB', db.ref(`/${this.$fbDbEntry}/${this.$route.params.raceId}/statusLive`))
    this.$bindAsObject('standByFB', db.ref(`/${this.$fbDbEntry}/${this.$route.params.raceId}/standBy`))
    this.getQuoteOfDay()

  },
  components: {
    RemainingTime,
    RaceQuestion,
    DatePicker,
    ModalOneSignal,
    Quote,
    SweetModal
  }
}
</script>
<style>

.question {
  border: 1px solid #66666673;
  border-radius: 20px;
  padding: 10px 15px 25px 15px;
  width: 100%;
}

#wrapper {
  width: 48% !important;
  padding-left: 0px !important;
  padding-bottom: 1rem !important;
  padding-right: 0 !important;
}

#questionWrapper {
  padding-left: 10px !important;
  padding-bottom: 1rem !important;
  padding-right: 10px !important;
  margin-top: 20px;
  width: 92%;
}

#leftcolumn {
  width: 80%;
}

#rightcolumn {
  /* padding-left: 6rem; */
  float: left;
  width: 15%;
  text-align: right;
}

a {
  text-decoration: none;
  color: rgb(16, 142, 233);
}

.notification-button {
  background: #f67242;
  border: #F67240;
  border-radius: 10px;
  height: 32px;
  /* margin-left: 6rem; */
  margin-top: -20px;
}

.notification-button:hover {
  background: #f67242;
  border: #F67240;
  border-radius: 10px;
  height: 32px;
  /* margin-left: 6rem; */
  margin-top: -20px;
}

.loadData {
  font-weight: 700;
  color: #fff;
  background-color: #423799;
  padding: 0px 10px;
  /* text-transform: uppercase; */
  position: sticky;
  left: 90%;
  transform: translateX(-50%);
  border-radius: 20px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.liveRaceContent header, .pastRunContent header {
  border: none;
}

.mic {
  cursor: pointer;
  /* position: absolute;
  width: 82px;
  height: 40px;
  padding: 6px;
  line-height: 6px;
  margin: auto;
  text-align: center;
  left: -80px;
  bottom: 0;
  top: 0; */
  color: rgb(244, 120, 90);
}

.recording-mic {
  width: 100%;
  text-align: center;
}

.steaming-url {
  margin-top: 10px;
  color: #f05529;
}

.rsvp_limit {
  margin-left: 50px
}

.channelInfo {
  color: #f05734;
  margin-top: 5px;
  font-size: 13px;
}
.autopilot-pill {
  display: inline-block;
  background-color: #f67242;
  color: white;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 11px;
  margin-left: 2px;
  margin-right: 5px;
  animation: blink 1.5s infinite;
}

.auto-start-button {
  display: inline-block;
  background-color: #999;
  color:white;
  border: none;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 10px;
  cursor: pointer;
  vertical-align: middle;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.auto-start-button::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: rgba(255, 255, 255, 0.1);
  transform: rotate(45deg);
  animation: lightRay 2s infinite;
  z-index: 1;
}

.auto-start-button:hover {
  background-color: #2ecc71;
  border-color: #2ecc71;
  color: white;
  box-shadow: 0 0 8px rgba(46, 204, 113, 0.5);
}

@keyframes lightRay {
  0% {
    transform: rotate(45deg) translateX(-100%);
  }
  100% {
    transform: rotate(45deg) translateX(100%);
  }
}

@keyframes blink {
  0% { opacity: 1; }
  50% { opacity: 0.5; }
  100% { opacity: 1; }
}

/* Custom tooltip styles */
.tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip .tooltip-inner {
  background: #444444 !important;
  color: white;
  border-radius: 4px;
  padding: 8px 10px;
  font-size: 12px;
  max-width: 250px;
  width: 250px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  text-align: center;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: #444444;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// Header.vue?305e504e